<script lang="ts">
  import { getContext } from 'svelte';
  import { push } from 'svelte-spa-router';
  import detail from '../etc/modal/billingDetail.svelte';
  const { open }: any = getContext('simple-modal');
  import RepositoryFactory, { HATENOHAMA } from '../repositories/RepositoryFactory';
  import Loading from '../etc/loader.svelte';
  import type { Bill, Detail } from '../repositories/hatneohama';
  import { loginUser } from '../components/auth/LoginUser';

  let detailMap: Map<string, Detail[]>;
  let isBillingMerge = false;
  let promise = getApi();

  // 契約情報取得
  async function getApi() {
    let bills: Bill[];
    const hatenohamaRepository = RepositoryFactory[HATENOHAMA];
    await hatenohamaRepository
      .getBill()
      .then((res) => {
        if (!res) {
          throw new Error();
        }
        bills = res.bills;
        detailMap = new Map(res.details.map((obj) => [obj.key, obj.details]));
        isBillingMerge = res.isBillingMerge;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
          return false;
        } else {
          alert('エラーが発生しました。');
          throw new Error();
        }
      });
    return bills;
  }

  const showDetailPopup = (bill: Bill) => {
    open(
      detail,
      {
        bill,
        details: Object.values(detailMap.get(bill.key))
      },
      { styleWindow: { width: '60rem' } }
    );
  };
</script>

<div class="screen-top">
  <div class="mb-5 screen-title">
    <span class="text-gray-700 text-2xl font-bold">請求金額確認</span>
  </div>
  <div class="mb-2 screen-button">
    <button on:click={() => push(`/invoice/`)} class="button-primary">請求書</button>
  </div>
</div>

{#await promise}
  <Loading />
{:then bills}
  <div class="shadow rounded-lg bg-gray-50 p-8 border-t-4 border-green-400">
    <div class="flex flex-col divide-y divide-gray-300">
      <div class="flex-auto flex flex-col">
        <div class="flex-auto">
          <div class="overflow-x-auto">
            <div class="align-middle inline-block min-w-full">
              <div class="overflow-auto">
                <table class="min-w-full border-collapse border border-gray-800">
                  <thead>
                    <tr>
                      <th class="w-1/4">請求年月日</th>
                      <th class="w-1/4">ご請求金額</th>
                      {#if isBillingMerge}
                        <th class="w-1/4">契約キー</th>
                      {/if}
                    </tr>
                  </thead>
                  <tbody class="">
                    {#each bills as bill}
                      <tr class="group" on:click={() => showDetailPopup(bill)}>
                        <td class="group-hover:bg-green-100">{bill.billYm}</td>
                        <td class="group-hover:bg-green-100">
                          <span class="tabular-nums">{bill.amount.toLocaleString('ja-JP')}円</span>
                        </td>
                        {#if isBillingMerge}
                          <td class="group-hover:bg-green-100">{bill.keyContract ?? '-'}</td>
                        {/if}
                      </tr>
                    {/each}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/await}

<style lang="postcss">
  thead tr th {
    @apply border border-gray-800 px-6 py-4 text-center text-sm text-gray-700 leading-4;
  }
  tbody tr td {
    @apply border border-gray-800 px-6 py-4 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-5 py-2;
  }
  .screen-top {
    @apply flex justify-between;
  }
  .screen-title {
    @apply text-left;
  }
  @media screen and (max-width: 640px) {
    .screen-top {
      @apply flex flex-col;
    }
    .screen-title {
      @apply text-center;
    }
    .screen-button {
      @apply mb-2.5 text-center;
    }
  }
</style>
